module.exports = __webpack_public_path__ + "static/media/notepad-icon-full.2d96015b.svg";